(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion-blocks"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('[data-accordion-blocks]');
    const accordions = section.querySelectorAll('[data-accordion]');

    accordions.forEach((accordion) => {
      const accordionTitle = accordion.querySelector('[data-accordion-title]');

      accordionTitle.addEventListener('click', (e) => {
        e.preventDefault();
        accordion.toggleAttribute('data-open');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-products-carousel"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', async () => {
    const { Swiper } = await import('@theme/swiper');

    class ProductsCarousel {
      constructor() {
        const section = document.querySelector('[data-products-carousel]');
        const carousel = section?.querySelector('[data-carousel]');
        const productsCarouselWrapper = document.querySelector(
          '.products-carousel-wrapper'
        );
        const articleWrapper = document.querySelector('.article-wrapper');

        this.initCarousel(carousel);
        this.initSticky(productsCarouselWrapper, articleWrapper);
      }

      initCarousel(carousel) {
        const slides = carousel?.querySelectorAll('.swiper-slide');
        if (slides?.length <= 1) return;

        const swiperConfig = {
          slidesPerView: 'auto',
          spaceBetween: 16,
          slidesOffsetBefore: 24,
          slidesOffsetAfter: 24,
          allowTouchMove: true,
          effect: 'slide',
          speed: 400,
          grabCursor: true,
          navigation: {
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          },
          breakpoints: {
            990: {
              slidesPerView: 1,
              spaceBetween: 24,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0,
            },
          },
        };

        const swiper = new Swiper(carousel, swiperConfig);
      }

      initSticky(stickyElement, scrollContainer) {
        if (!stickyElement || !scrollContainer) return;

        const checkBottomVisibility = () => {
          const rect = scrollContainer.getBoundingClientRect();
          const bottomVisible = rect.bottom <= window.innerHeight;

          stickyElement.classList.remove('is-sticky-hidden');
          if (bottomVisible) {
            stickyElement.classList.add('is-sticky-hidden');
          }
        };

        window.addEventListener('scroll', checkBottomVisibility);
        checkBottomVisibility();
      }
    }

    new ProductsCarousel();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-featured"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', async () => {
    const { Swiper } = await import('@theme/swiper');

    const sections = document.querySelectorAll('[data-blog-featured]');

    sections.forEach((section) => {
      const carousel = section.querySelector('[data-carousel]');

      const slides = carousel.querySelectorAll('.swiper-slide');
      if (slides.length <= 1) return;

      const swiperConfig = {
        slidesPerView: 'auto',
        spaceBetween: 16,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
        allowTouchMove: true,
        effect: 'slide',
        speed: 400,
        grabCursor: true,
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        },
        breakpoints: {
          990: {
            slidesOffsetBefore: 64,
            slidesOffsetAfter: 64,
            grabCursor: false,
          },
        },
      };

      const swiper = new Swiper(carousel, swiperConfig);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel-full-width"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', async () => {
    const { Swiper } = await import('@theme/swiper');

    const sections = document.querySelectorAll('[data-collection-carousel-fw]');

    sections.forEach((section) => {
      const carousel = section.querySelector('[data-carousel-fw]');

      const slides = carousel.querySelectorAll('.swiper-slide');
      if (slides.length <= 1) return;

      const swiperConfig = {
        slidesPerView: 'auto',
        spaceBetween: 16,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
        allowTouchMove: true,
        effect: 'slide',
        speed: 400,
        grabCursor: true,
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        },
        breakpoints: {
          990: {
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
          },
        },
      };

      const swiper = new Swiper(carousel, swiperConfig);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["categories-extended"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', async () => {
    const { Swiper } = await import('@theme/swiper');

    const sections = document.querySelectorAll('[data-categories-extended]');

    sections.forEach((section) => {
      const carousel = section.querySelector('[data-carousel]');

      const slides = carousel.querySelectorAll('.swiper-slide');
      if (slides.length <= 1) return;

      const swiperConfig = {
        slidesPerView: 'auto',
        spaceBetween: 16,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
        allowTouchMove: true,
        effect: 'slide',
        speed: 400,
        grabCursor: true,
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        },
        breakpoints: {
          990: {
            slidesOffsetBefore: 64,
            slidesOffsetAfter: 64,
          },
          1560: {
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
          },
        },
      };

      const swiper = new Swiper(carousel, swiperConfig);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["categories"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', async () => {
    const { Swiper } = await import('@theme/swiper');

    const sections = document.querySelectorAll('[data-categories]');

    sections.forEach((section) => {
      const carousel = section.querySelector('[data-carousel]');

      const slides = carousel.querySelectorAll('.swiper-slide');
      if (slides.length <= 1) return;

      const swiperConfig = {
        slidesPerView: 'auto',
        spaceBetween: 16,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
        allowTouchMove: true,
        effect: 'slide',
        speed: 400,
        grabCursor: true,
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        },
        breakpoints: {
          990: {
            slidesOffsetBefore: 64,
            slidesOffsetAfter: 64,
          },
          1560: {
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
          },
        },
      };

      const swiper = new Swiper(carousel, swiperConfig);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', async () => {
    const { Swiper } = await import('@theme/swiper');

    const sections = document.querySelectorAll('[data-collection-carousel]');

    sections.forEach((section) => {
      const carousel = section.querySelector('[data-carousel]');

      const slides = carousel.querySelectorAll('.swiper-slide');
      if (slides.length <= 1) return;

      const swiperConfig = {
        slidesPerView: 'auto',
        spaceBetween: 16,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
        allowTouchMove: true,
        effect: 'slide',
        speed: 400,
        grabCursor: true,
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        },
        breakpoints: {
          990: {
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
          },
        },
      };

      const swiper = new Swiper(carousel, swiperConfig);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["events-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('events-carousel')) return;

    // Accepts "2026-08-15T10:00:00", "2026-08-15 10:00", "2026-08-15" etc.
    function formatDT(value) {
      var digits = (value || '').replace(/\D/g, '');
      if (digits.length < 8) return '';
      digits = (digits + '000000').substring(0, 14);
      return digits.substring(0, 8) + 'T' + digits.substring(8, 14);
    }

    function escapeICS(text) {
      return (text || '')
        .replace(/\\/g, '\\\\')
        .replace(/;/g, '\\;')
        .replace(/,/g, '\\,')
        .replace(/\r?\n/g, '\\n');
    }

    function closeAllDropdowns() {
      document.querySelectorAll('[data-cal-dropdown].is-open').forEach(function (d) {
        d.classList.remove('is-open');
      });
      document.querySelectorAll('[data-cal-toggle]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
    }

    customElements.define('events-carousel', class extends HTMLElement {
      constructor() {
        super();
        this.currentIndex = 0;
        this.itemsPerView = 3;
        this.handleResize = this.refresh.bind(this);
        this.handleClick = this.onClick.bind(this);
        this.handleBlockSelect = this.onBlockSelect.bind(this);
      }

      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prevButton = this.querySelector('[data-prev]');
        this.nextButton = this.querySelector('[data-next]');

        this.prevButton.addEventListener('click', () => this.go(-1));
        this.nextButton.addEventListener('click', () => this.go(1));
        this.addEventListener('click', this.handleClick);
        window.addEventListener('resize', this.handleResize);
        document.addEventListener('click', closeAllDropdowns);

        // Theme editor: when an event is clicked in the sidebar, slide to it
        document.addEventListener('shopify:block:select', this.handleBlockSelect);

        this.refresh();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
        document.removeEventListener('click', closeAllDropdowns);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      }

      get items() {
        return this.track.querySelectorAll('[data-carousel-item]');
      }

      maxIndex() {
        return Math.max(0, this.items.length - this.itemsPerView);
      }

      refresh() {
        var perView = parseInt(getComputedStyle(this).getPropertyValue('--items-per-view'), 10);
        this.itemsPerView = perView > 0 ? perView : 3;
        if (this.currentIndex > this.maxIndex()) this.currentIndex = this.maxIndex();
        this.update();
      }

      go(direction) {
        var next = this.currentIndex + direction;
        if (next < 0 || next > this.maxIndex()) return;
        this.currentIndex = next;
        this.update();
      }

      update() {
        var items = this.items;
        if (items.length) {
          var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          var offset = -(this.currentIndex * (items[0].offsetWidth + gap));
          this.track.style.transform = 'translateX(' + offset + 'px)';
        } else {
          this.track.style.transform = '';
        }
        this.prevButton.disabled = this.currentIndex === 0;
        this.nextButton.disabled = this.currentIndex >= this.maxIndex();
      }

      onBlockSelect(e) {
        var items = Array.prototype.slice.call(this.items);
        var index = items.findIndex(function (el) {
          return el.dataset.blockId === e.detail.blockId;
        });
        if (index === -1) return;
        this.currentIndex = Math.min(index, this.maxIndex());
        this.update();
      }

      onClick(e) {
        var toggle = e.target.closest('[data-cal-toggle]');
        if (toggle) {
          e.stopPropagation();
          this.toggleCalendar(toggle);
          return;
        }

        var ics = e.target.closest('[data-cal-ics]');
        if (ics) {
          e.stopPropagation();
          this.downloadICS(ics.closest('[data-cal]'));
          closeAllDropdowns();
        }
      }

      toggleCalendar(btn) {
        var wrapper = btn.closest('[data-cal]');
        var dropdown = wrapper.querySelector('[data-cal-dropdown]');
        var wasOpen = dropdown.classList.contains('is-open');

        closeAllDropdowns();
        if (wasOpen) return;

        dropdown.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');

        var d = wrapper.dataset;
        var start = formatDT(d.eventStart);
        var end = formatDT(d.eventEnd) || start;
        var googleLink = wrapper.querySelector('[data-cal-google]');
        if (googleLink) {
          googleLink.href = 'https://calendar.google.com/calendar/render?action=TEMPLATE'
            + '&text=' + encodeURIComponent(d.eventTitle || '')
            + '&dates=' + start + '/' + end
            + '&location=' + encodeURIComponent(d.eventLocation || '')
            + '&details=' + encodeURIComponent(d.eventDescription || '');
        }
      }

      downloadICS(wrapper) {
        var d = wrapper.dataset;
        var start = formatDT(d.eventStart);
        var end = formatDT(d.eventEnd) || start;
        var stamp = new Date().toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
        var uid = start + '-' + Math.random().toString(36).slice(2) + '@' + window.location.hostname;

        var ics = [
          'BEGIN:VCALENDAR',
          'VERSION:2.0',
          'PRODID:-//Koorong//Events//EN',
          'BEGIN:VEVENT',
          'UID:' + uid,
          'DTSTAMP:' + stamp,
          'DTSTART:' + start,
          'DTEND:' + end,
          'SUMMARY:' + escapeICS(d.eventTitle),
          'LOCATION:' + escapeICS(d.eventLocation),
          'DESCRIPTION:' + escapeICS(d.eventDescription),
          'END:VEVENT',
          'END:VCALENDAR'
        ].join('\r\n');

        var blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = (d.eventTitle || 'event') + '.ics';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card"]) return;
  try {
    
  class GiftCardCode extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.gift-card__code');
      this.codeText = this.querySelector('.gift-card__code-text');
      this.copiedMessage = this.querySelector('.gift-card__copied');
      this.code = this.codeText.textContent.trim().replace(/\s/g, '');

      this.button.addEventListener('click', () => this.#copyToClipboard());
    }

    async #copyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.code);
        this.#showCopiedMessage();
      } catch (err) {
        console.error('Failed to copy:', err);
      }
    }

    #showCopiedMessage() {
      // this.codeText.hidden = true;
      this.copiedMessage.hidden = false;

      setTimeout(() => {
        this.copiedMessage.hidden = true;
        // this.codeText.hidden = false;
      }, 2000);
    }
  }

  customElements.define('gift-card-code', GiftCardCode);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class TypewriterPlaceholder {
    #prefix = 'Search for ';
    #words = ['authors', 'titles', 'topics'];
    #pauseDuration = 2000;
    #typeSpeed = { min: 80, max: 150 };
    #deleteSpeed = { min: 40, max: 80 };
    #target = null;
    #wordIndex = 0;
    #running = false;
    #timeout = null;

    constructor(target, words) {
      this.#target = target;
      if (words && words.length) this.#words = words;
    }

    start() {
      if (this.#running) return;
      this.#running = true;
      this.#type('');
    }

    stop() {
      this.#running = false;
      clearTimeout(this.#timeout);
      this.#target.textContent = '';
    }

    #type(current) {
      if (!this.#running) return;

      const word = this.#words[this.#wordIndex];

      if (current.length < word.length) {
        const next = word.slice(0, current.length + 1);
        this.#target.textContent = this.#prefix + next;
        this.#timeout = setTimeout(
          () => this.#type(next),
          this.#rand(this.#typeSpeed.min, this.#typeSpeed.max)
        );
      } else {
        this.#timeout = setTimeout(
          () => this.#delete(word),
          this.#pauseDuration
        );
      }
    }

    #delete(current) {
      if (!this.#running) return;

      if (current.length > 0) {
        const next = current.slice(0, -1);
        this.#target.textContent = this.#prefix + next;
        this.#timeout = setTimeout(
          () => this.#delete(next),
          this.#rand(this.#deleteSpeed.min, this.#deleteSpeed.max)
        );
      } else {
        this.#wordIndex = (this.#wordIndex + 1) % this.#words.length;
        this.#timeout = setTimeout(
          () => this.#type(''),
          this.#rand(200, 400)
        );
      }
    }

    #rand(min, max) {
      return Math.random() * (max - min) + min;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const searchLink = document.querySelector(
      '.header__inner.is-desktop .header__search'
    );

    if (!searchLink) return;

    const target = searchLink.querySelector('.header__search-text');

    if (!target) return;

    const wordsRaw = searchLink.dataset.typewriterWords ?? '';
    const words = wordsRaw
      .split(',')
      .map((w) => w.trim())
      .filter(Boolean);

    const typewriter = new TypewriterPlaceholder(target, words);

    const mq = window.matchMedia('(min-width: 990px)');

    const handleViewport = (e) => {
      if (e.matches) {
        typewriter.start();
      } else {
        typewriter.stop();
      }
    };

    mq.addEventListener('change', handleViewport);
    handleViewport(mq);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-hub"]) return;
  try {
    
  class HelpHub extends HTMLElement {
    constructor() {
      super();
      this.setupEventListeners();
      this.initializeSearch();
      this.initializeCategories();
    }

    setupEventListeners() {
      // Accordion toggles for main FAQs
      this.addEventListener('click', (event) => {
        if (event.target.closest('.help-hub__faq-toggle')) {
          this.handleFaqToggle(event.target.closest('.help-hub__faq-toggle'));
        }

        // Accordion toggles for sub FAQs
        if (event.target.closest('.help-hub__sub-faq-toggle')) {
          this.handleSubFaqToggle(
            event.target.closest('.help-hub__sub-faq-toggle')
          );
        }

        // Category filtering
        if (event.target.closest('.help-hub__category')) {
          this.handleCategoryClick(event.target.closest('.help-hub__category'));
        }
      });

      // Mobile category select
      const categorySelect = this.querySelector('[data-category-select]');
      if (categorySelect) {
        categorySelect.addEventListener('change', (event) => {
          this.handleMobileCategoryChange(event.target.value);
        });
      }
    }

    initializeSearch() {
      const searchInput = this.querySelector('.help-hub__search-input');
      if (!searchInput) return;

      searchInput.addEventListener('input', (event) => {
        this.handleSearch(event.target.value);
      });
    }

    initializeCategories() {
      // Initialize with first category
      const firstCategoryButton = this.querySelector('.help-hub__category');
      if (firstCategoryButton) {
        const firstCategoryId = firstCategoryButton.dataset.category;

        // Set first category as active
        firstCategoryButton.classList.add('is-active');

        // Initialize mobile select with first category
        const mobileSelect = this.querySelector('[data-category-select]');
        if (mobileSelect) {
          mobileSelect.value = firstCategoryId;
        }

        // Filter FAQs by first category
        this.filterFaqsByCategory(firstCategoryId);
      }
    }

    handleFaqToggle(toggle) {
      const faq = toggle.closest('.help-hub__faq');
      const content = faq.querySelector('.help-hub__faq-content');
      const isOpen = faq.classList.contains('is-open');

      if (isOpen) {
        this.closeFaq(faq, content, toggle);
      } else {
        this.openFaq(faq, content, toggle);
      }
    }

    handleSubFaqToggle(toggle) {
      const subFaq = toggle.closest('.help-hub__sub-faq');
      const content = subFaq.querySelector('.help-hub__sub-faq-content');
      const isOpen = subFaq.classList.contains('is-open');

      if (isOpen) {
        this.closeSubFaq(subFaq, content, toggle);
      } else {
        this.openSubFaq(subFaq, content, toggle);
      }
    }

    openFaq(faq, content, toggle) {
      faq.classList.add('is-open');
      content.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');

      // Smooth height animation
      this.animateHeight(content, 0, content.scrollHeight);
    }

    closeFaq(faq, content, toggle) {
      const currentHeight = content.scrollHeight;

      this.animateHeight(content, currentHeight, 0, () => {
        faq.classList.remove('is-open');
        content.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      });
    }

    openSubFaq(subFaq, content, toggle) {
      subFaq.classList.add('is-open');
      content.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');

      this.animateHeight(content, 0, content.scrollHeight);
    }

    closeSubFaq(subFaq, content, toggle) {
      const currentHeight = content.scrollHeight;

      this.animateHeight(content, currentHeight, 0, () => {
        subFaq.classList.remove('is-open');
        content.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      });
    }

    animateHeight(element, startHeight, endHeight, callback) {
      element.style.height = startHeight + 'px';
      element.style.overflow = 'hidden';

      requestAnimationFrame(() => {
        element.style.transition = 'height 0.2s ease';
        element.style.height = endHeight + 'px';

        const handleTransitionEnd = () => {
          element.style.height = '';
          element.style.overflow = '';
          element.style.transition = '';
          element.removeEventListener('transitionend', handleTransitionEnd);
          if (callback) callback();
        };

        element.addEventListener('transitionend', handleTransitionEnd);
      });
    }

    handleCategoryClick(categoryButton) {
      const category = categoryButton.dataset.category;

      // Update active state
      this.querySelectorAll('.help-hub__category').forEach((btn) => {
        btn.classList.remove('is-active');
      });
      categoryButton.classList.add('is-active');

      // Update mobile select to match
      const mobileSelect = this.querySelector('[data-category-select]');
      if (mobileSelect) {
        mobileSelect.value = category;
      }

      // Filter FAQs
      this.filterFaqsByCategory(category);

      // Hide search no results text
      const noResultsEl = this.querySelector('.help-hub__search-no-results');
      noResultsEl?.classList.add('is-hidden');

      // Clear search text
      const searchInput = this.querySelector('.help-hub__search-input');
      if (searchInput) {
        searchInput.value = '';
      }
    }

    handleMobileCategoryChange(categoryValue) {
      // Update desktop buttons to match
      this.querySelectorAll('.help-hub__category').forEach((btn) => {
        btn.classList.remove('is-active');
        if (btn.dataset.category === categoryValue) {
          btn.classList.add('is-active');
        }
      });

      // Filter FAQs
      this.filterFaqsByCategory(categoryValue);
    }

    filterFaqsByCategory(category) {
      const faqs = this.querySelectorAll('.help-hub__faq');

      faqs.forEach((faq) => {
        const faqCategory = faq.dataset.category;
        const shouldShow = faqCategory === category;

        if (shouldShow) {
          faq.classList.add('is-visible');
          faq.style.display = '';
        } else {
          faq.classList.remove('is-visible');
          faq.style.display = 'none';
          // Reset FAQ state if it's open
          if (faq.classList.contains('is-open')) {
            faq.classList.remove('is-open');
            const toggle = faq.querySelector('.help-hub__faq-toggle');
            const content = faq.querySelector('.help-hub__faq-content');
            if (toggle) toggle.setAttribute('aria-expanded', 'false');
            if (content) {
              content.hidden = true;
              content.style.height = '';
              content.style.overflow = '';
              content.style.transition = '';
            }

            // Also close any open sub-FAQs
            const subFaqs = faq.querySelectorAll('.help-hub__sub-faq.is-open');
            subFaqs.forEach((subFaq) => {
              subFaq.classList.remove('is-open');
              const subToggle = subFaq.querySelector(
                '.help-hub__sub-faq-toggle'
              );
              const subContent = subFaq.querySelector(
                '.help-hub__sub-faq-content'
              );
              if (subToggle) subToggle.setAttribute('aria-expanded', 'false');
              if (subContent) {
                subContent.hidden = true;
                subContent.style.height = '';
                subContent.style.overflow = '';
                subContent.style.transition = '';
              }
            });
          }
        }
      });
    }

    handleSearch(query) {
      const normalizedQuery = query.toLowerCase().trim();

      if (normalizedQuery === '') {
        this.clearSearch();
        return;
      }

      this.performSearch(normalizedQuery);
    }

      performSearch(query) {
    const faqs = this.querySelectorAll('.help-hub__faq');
    let hasResults = false;
    const seenTitles = new Set();

    // Reset category filter when searching
    this.querySelectorAll('.help-hub__category').forEach((btn) => {
      btn.classList.remove('is-active');
    });

    const noResultsEl = this.querySelector('.help-hub__search-no-results');
    noResultsEl?.classList.add('is-hidden');

    faqs.forEach((faq) => {
      const faqTitleEl = faq.querySelector('.help-hub__faq-title');
      const faqTitle = faqTitleEl ? faqTitleEl.textContent.trim() : null;
      const isDuplicate = faqTitle && seenTitles.has(faqTitle);
      const matchesQuery = this.searchInFaq(faq, query);
      const shouldShow = matchesQuery && !isDuplicate;

      if (matchesQuery && faqTitle) {
        seenTitles.add(faqTitle);
      }

      if (shouldShow) {
        faq.classList.add('is-visible');
        faq.style.display = '';
        hasResults = true;
      } else {
        faq.classList.remove('is-visible');
        faq.style.display = 'none';
        // Reset FAQ state if it's open
        if (faq.classList.contains('is-open')) {
          faq.classList.remove('is-open');
          const toggle = faq.querySelector('.help-hub__faq-toggle');
          const content = faq.querySelector('.help-hub__faq-content');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
          if (content) {
            content.hidden = true;
            content.style.height = '';
            content.style.overflow = '';
            content.style.transition = '';
          }

          const subFaqs = faq.querySelectorAll('.help-hub__sub-faq.is-open');
          subFaqs.forEach((subFaq) => {
            subFaq.classList.remove('is-open');
            const subToggle = subFaq.querySelector('.help-hub__sub-faq-toggle');
            const subContent = subFaq.querySelector('.help-hub__sub-faq-content');
            if (subToggle) subToggle.setAttribute('aria-expanded', 'false');
            if (subContent) {
              subContent.hidden = true;
              subContent.style.height = '';
              subContent.style.overflow = '';
              subContent.style.transition = '';
            }
          });
        }
      }
    });

    if (!hasResults) {
      noResultsEl?.classList.remove('is-hidden');
    }

    const categoriesMobile = this.querySelector('.help-hub__categories.is-mobile');
    categoriesMobile.classList.add('is-hidden');
  }
    searchInFaq(faq, query) {
      // Search in FAQ title
      const faqTitle = faq.querySelector('.help-hub__faq-title');
      if (faqTitle && faqTitle.textContent.toLowerCase().includes(query)) {
        return true;
      }

      // Search in FAQ content
      const faqText = faq.querySelector('.help-hub__faq-text');
      if (faqText && faqText.textContent.toLowerCase().includes(query)) {
        return true;
      }

      // Search in sub-FAQ titles and content
      const subFaqTitles = faq.querySelectorAll('.help-hub__sub-faq-title');
      const subFaqTexts = faq.querySelectorAll('.help-hub__sub-faq-text');

      const subFaqMatches = [...subFaqTitles, ...subFaqTexts].some((element) =>
        element.textContent.toLowerCase().includes(query)
      );

      return subFaqMatches;
    }

    clearSearch() {
      // Show FAQs based on current category filter
      const activeCategory = this.querySelector(
        '.help-hub__category.is-active'
      );
      if (activeCategory) {
        this.filterFaqsByCategory(activeCategory.dataset.category);
      } else {
        // If no active category, select first category
        const firstCategory = this.querySelector('.help-hub__category');
        if (firstCategory) {
          firstCategory.classList.add('is-active');

          // Update mobile select to match
          const mobileSelect = this.querySelector('[data-category-select]');
          if (mobileSelect) {
            mobileSelect.value = firstCategory.dataset.category;
          }

          this.filterFaqsByCategory(firstCategory.dataset.category);
        }
      }

      // Show mobile categories selector
      const categoriesMobile = this.querySelector(
        '.help-hub__categories.is-mobile'
      );
      categoriesMobile.classList.remove('is-hidden');
    }
  }

  // Register the custom element
  customElements.define('help-hub', HelpHub);

  // Initialize help hub when the DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    const helpHubElement = document.querySelector('.help-hub');
    if (helpHubElement && !customElements.get('help-hub')) {
      // Fallback for browsers that don't support custom elements
      new HelpHub();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', async () => {
    const { Swiper } = await import('@theme/swiper');

    const sections = document.querySelectorAll('[data-hero]');

    sections.forEach((section) => {
      const carousel = section.querySelector('[data-carousel]');
      const autoplayEnabled = section.dataset.autoplayEnabled === 'true';
      const autoplayDelay = parseInt(section.dataset.autoplayDelay) || 4000;

      const slides = carousel.querySelectorAll('.swiper-slide');
      if (slides.length <= 1) return;

      const swiperConfig = {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: true,
        effect: 'slide',
        speed: 400,
        grabCursor: true,
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        },
      };

      const swiper = new Swiper(carousel, swiperConfig);

      if (autoplayEnabled) {
        setInterval(() => swiper.slideNext(), autoplayDelay);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-carousel-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', async () => {
    const { Swiper } = await import('@theme/swiper');

    const sections = document.querySelectorAll('[data-image-carousel-content]');

    sections.forEach((section) => {
      const carousel = section.querySelector('[data-carousel]');

      const slides = carousel.querySelectorAll('.swiper-slide');
      if (slides.length <= 1) return;

      const swiperConfig = {
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 16,
        allowTouchMove: true,
        effect: 'slide',
        speed: 400,
        grabCursor: true,
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        },
      };

      const swiper = new Swiper(carousel, swiperConfig);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', async () => {
    const { Swiper } = await import('@theme/swiper');

    const sections = document.querySelectorAll('[data-image-gallery-carousel]');

    sections.forEach((section) => {
      const carousel = section.querySelector('[data-carousel]');

      const slides = carousel.querySelectorAll('.swiper-slide');
      if (slides.length <= 1) return;

      const swiperConfig = {
        slidesPerView: 'auto',
        spaceBetween: 16,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
        allowTouchMove: true,
        effect: 'slide',
        speed: 400,
        grabCursor: true,
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        },
        breakpoints: {
          990: {
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
        },
      };

      const swiper = new Swiper(carousel, swiperConfig);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', async () => {
    const { Swiper } = await import('@theme/swiper');

    const section = document.querySelector('[data-product-details]');
    const accordions = section.querySelectorAll('[data-accordion]');

    accordions.forEach((accordion) => {
      const accordionTitle = accordion.querySelector('[data-accordion-title]');

      accordionTitle.addEventListener('click', (e) => {
        e.preventDefault();
        accordion.toggleAttribute('data-open');
      });
    });

    const endorsementsRichtextCarousel = section.querySelector(
      '[data-endorsements-richtext-carousel]'
    );
    const endorsementsCarousel = section.querySelector(
      '[data-endorsements-carousel]'
    );
    const endorsementsSlides = endorsementsCarousel?.querySelectorAll(
      '[data-endorsements-slide]'
    );
    const podcastMentionsCarousel = section.querySelector(
      '[data-podcast-mentions-carousel]'
    );
    const podcastMentionsSlides = podcastMentionsCarousel?.querySelectorAll(
      '[data-podcast-mentions-slide]'
    );
    const catalogueMentionsCarousel = section.querySelector(
      '[data-catalogue-mentions-carousel]'
    );
    const catalogueMentionsSlides = catalogueMentionsCarousel?.querySelectorAll(
      '[data-catalogue-mentions-slide]'
    );
    const blogMentionsCarousel = section.querySelector(
      '[data-blog-mentions-carousel]'
    );
    const blogMentionsSlides = blogMentionsCarousel?.querySelectorAll(
      '[data-blog-mentions-slide]'
    );

    const carouselSwiperConfig = {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 16,
      allowTouchMove: true,
      effect: 'slide',
      speed: 400,
      grabCursor: true,
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      },
    };

    if (endorsementsRichtextCarousel) {
      const bodyEl = endorsementsRichtextCarousel.querySelector(
        '[data-endorsements-richtext-body]'
      );
      const wrapperEl = bodyEl.querySelector(
        '[data-endorsements-richtext-wrapper]'
      );
      const headerEl = endorsementsRichtextCarousel.querySelector(
        '[data-endorsement-richtext-header]'
      );
      const dividerEl = endorsementsRichtextCarousel.querySelector(
        '[data-endorsement-richtext-divider]'
      );
      const readMoreBtn = endorsementsRichtextCarousel.querySelector(
        '[data-endorsement-readmore]'
      );
      const richtextSlides = wrapperEl.querySelectorAll(':scope > .endorsement');

      if (richtextSlides.length > 0) {
        endorsementsRichtextCarousel.setAttribute('data-mode', 'carousel');
        headerEl.hidden = false;
        dividerEl.hidden = false;
        bodyEl.classList.add('swiper');
        wrapperEl.classList.add('swiper-wrapper');
        richtextSlides.forEach((slide) => slide.classList.add('swiper-slide'));

        const counterEl = endorsementsRichtextCarousel.querySelector(
          '[data-endorsement-counter]'
        );
        const prevBtn = endorsementsRichtextCarousel.querySelector(
          '[data-endorsement-richtext-prev]'
        );
        const nextBtn = endorsementsRichtextCarousel.querySelector(
          '[data-endorsement-richtext-next]'
        );
        const total = richtextSlides.length;

        const updateCounter = (index) => {
          if (counterEl) counterEl.textContent = (index + 1) + '/' + total;
        };
        updateCounter(0);

        new Swiper(bodyEl, {
          loop: false,
          slidesPerView: 1,
          autoHeight: true,
          spaceBetween: 16,
          allowTouchMove: true,
          effect: 'slide',
          speed: 400,
          grabCursor: true,
          navigation: {
            prevEl: prevBtn,
            nextEl: nextBtn,
          },
          on: {
            slideChange: function () {
              updateCounter(this.activeIndex);
            },
          },
        });
      } else {
        endorsementsRichtextCarousel.setAttribute('data-mode', 'single');

        if (bodyEl.scrollHeight > bodyEl.clientHeight + 1) {
          readMoreBtn.hidden = false;
        }

        readMoreBtn.addEventListener('click', () => {
          endorsementsRichtextCarousel.setAttribute('data-expanded', '');
          readMoreBtn.hidden = true;
        });
      }
    }

    if (endorsementsCarousel && endorsementsSlides.length > 0) {
      const endorsementsCarouselSwiper = new Swiper(
        endorsementsCarousel,
        carouselSwiperConfig
      );
    }

    if (podcastMentionsCarousel && podcastMentionsSlides.length > 0) {
      const podcastMentionsCarouselSwiper = new Swiper(
        podcastMentionsCarousel,
        carouselSwiperConfig
      );
    }

    if (catalogueMentionsCarousel && catalogueMentionsSlides.length > 0) {
      const catalogueMentionsCarouselSwiper = new Swiper(
        catalogueMentionsCarousel,
        carouselSwiperConfig
      );
    }

    if (blogMentionsCarousel && blogMentionsSlides.length > 0) {
      const blogMentionsCarouselSwiper = new Swiper(
        blogMentionsCarousel,
        carouselSwiperConfig
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"]) return;
  try {
    
  // Rebuilds a table of contents that arrives as one flat string with no line breaks.
  // Splits on "Part N." headings and sequential chapter numbers (1, 2, 3...).
  // Leaves content alone if it already has structure or has no numbered chapters.
  function formatFlatToc(container) {
    if (!container) return;

    // Already structured, nothing to do
    if (container.querySelectorAll('p, br, li, h1, h2, h3, h4, h5, h6').length > 1) return;

    const text = container.textContent.replace(/\s+/g, ' ').trim();
    if (!text) return;

    // Find chapter numbers in sequence
    const starts = [];
    let n = 1;
    let from = 0;
    while (true) {
      const re = new RegExp('(?<!\\d)' + n + ' (?=\\S)', 'g');
      re.lastIndex = from;
      const m = re.exec(text);
      if (!m) break;
      starts.push(m.index);
      from = m.index + String(n).length;
      n++;
    }
    if (!starts.length) return;

    // Add a space where a subtitle has been joined to a title, e.g. "ItA Short"
    const fixSpacing = (s) => s.replace(/([a-z?!’”)])([A-Z])/g, '$1 $2');

    const items = [];
    const intro = text.slice(0, starts[0]).trim();
    if (intro) items.push({ type: /^Part \d/.test(intro) ? 'part' : 'intro', text: intro });

    starts.forEach((start, i) => {
      const seg = text.slice(start, starts[i + 1] ?? text.length);
      const partMatch = seg.match(/Part \d+\..*$/);
      const chapter = partMatch ? seg.slice(0, partMatch.index) : seg;
      items.push({ type: 'chapter', text: fixSpacing(chapter.trim()) });
      if (partMatch) items.push({ type: 'part', text: partMatch[0].trim() });
    });

    // Rebuild: Part headings in bold, chapters as lines underneath
    container.innerHTML = '';
    let block = null;
    items.forEach((item) => {
      if (item.type === 'chapter') {
        if (!block) {
          block = document.createElement('p');
          container.appendChild(block);
        } else {
          block.appendChild(document.createElement('br'));
        }
        block.appendChild(document.createTextNode(item.text));
      } else {
        block = null;
        const p = document.createElement('p');
        if (item.type === 'part') {
          const strong = document.createElement('strong');
          strong.textContent = item.text;
          p.appendChild(strong);
        } else {
          p.textContent = item.text;
        }
        container.appendChild(p);
      }
    });
  }

  // Product TOC Modal
  document.querySelectorAll('[data-product-toc-trigger]').forEach((trigger) => {
    const modalId = trigger.getAttribute('aria-controls');
    const modal = document.getElementById(modalId);
    if (!modal) return;

    formatFlatToc(modal.querySelector('.product-toc__content'));

    document.body.appendChild(modal);

    const closeEls = modal.querySelectorAll('[data-product-toc-close]');

    const openModal = () => {
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      trigger.focus();
    };

    trigger.addEventListener('click', openModal);
    closeEls.forEach((el) => el.addEventListener('click', closeModal));

    modal.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeModal();
    });
  });

  document.addEventListener('DOMContentLoaded', async () => {
    const { Swiper } = await import('@theme/swiper');

    const imagesSection = document.querySelector('[data-product-images]');
    const mainCarousel = imagesSection.querySelector('[data-carousel]');
    const thumbnailCarousel = imagesSection.querySelector('[data-thumbnail-carousel]');
    const slides = mainCarousel.querySelectorAll('.swiper-slide');
    const thumbnailSlides = thumbnailCarousel.querySelectorAll('.swiper-slide');

    const productSticky = document.querySelector('[data-product-sticky]');
    const productStickyClose = document.querySelector('[data-product-sticky-close]');
    const productForm = document.querySelector('[data-product-template-form]');
    const footerSection = document.querySelector('[data-footer-section]');

    const productDescriptions = document.querySelectorAll('[data-description]');
    productDescriptions.forEach((productDescription) => {
      const descriptionReadMoreButton = productDescription.querySelector('[data-description-read-more]');
      const descriptionReadLessButton = productDescription.querySelector('[data-description-read-less]');

      descriptionReadMoreButton?.addEventListener('click', (e) => {
        e.preventDefault();
        productDescription.setAttribute('data-show-description', 'true');
      });

      descriptionReadLessButton?.addEventListener('click', (e) => {
        e.preventDefault();
        productDescription.removeAttribute('data-show-description');
      });
    });

    if (slides.length > 1) {
      const dotsContainer = document.getElementById('product-images-dots');

      function updateDots(swiper) {
        if (!dotsContainer) return;
        dotsContainer.querySelectorAll('.dot').forEach((d, i) => {
          d.classList.toggle('is-active', i === swiper.activeIndex);
        });
      }

      function buildDots(swiper) {
        if (!dotsContainer) return;
        dotsContainer.innerHTML = '';
        const total = swiper.slides.length;
        for (let i = 0; i < total; i++) {
          const dot = document.createElement('button');
          dot.classList.add('dot');
          if (i === swiper.activeIndex) dot.classList.add('is-active');
          dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
          dot.addEventListener('click', () => {
            swiper.slideTo(i);
            thumbnailSlides.forEach((slide) => slide.classList.remove('is-selected'));
            if (thumbnailSlides[i]) thumbnailSlides[i].classList.add('is-selected');
            updateDots(swiper);
          });
          dotsContainer.appendChild(dot);
        }
      }

      const mainCarouselSwiperConfig = {
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: 40,
        slidesOffsetBefore: 40,
        slidesOffsetAfter: 40,
        allowTouchMove: true,
        effect: 'slide',
        speed: 400,
        grabCursor: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar',
        },
        breakpoints: {
          990: {
            spaceBetween: 16,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            pagination: false,
          },
        },
        on: {
          init(swiper) {
            buildDots(swiper);
          },
          slideChange(swiper) {
            updateDots(swiper);
          },
        },
      };

      const thumbnailCarouselSwiperConfig = {
        enabled: false,
        breakpoints: {
          990: {
            enabled: true,
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 8,
            allowTouchMove: true,
            effect: 'slide',
            speed: 400,
            grabCursor: true,
          },
        },
      };

      const mainCarouselSwiper = new Swiper(mainCarousel, mainCarouselSwiperConfig);
      const thumbnailCarouselSwiper = new Swiper(thumbnailCarousel, thumbnailCarouselSwiperConfig);

      thumbnailCarouselSwiper.on('click', () => {
        const clickedSlide = thumbnailCarouselSwiper.clickedSlide;
        const clickedSlideIndex = clickedSlide?.dataset.index;
        if (!clickedSlideIndex) return;
        mainCarouselSwiper.slideTo(clickedSlideIndex);

        thumbnailSlides.forEach((slide) => slide.classList.remove('is-selected'));
        clickedSlide.classList.add('is-selected');

        updateDots(mainCarouselSwiper);
      });
    }

    if (productSticky && productStickyClose && productForm && footerSection) {
      let isProductFormPastViewport = false;
      let isFooterInViewport = false;

      const updateStickyState = () => {
        if (isProductFormPastViewport && !isFooterInViewport) {
          productSticky.classList.add('is-active');
        } else {
          productSticky.classList.remove('is-active');
        }
      };

      const productFormObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              isProductFormPastViewport = false;
            } else {
              const rect = entry.boundingClientRect;
              isProductFormPastViewport = rect.top < 0;
            }
            updateStickyState();
          });
        },
        { rootMargin: '0px 0px 0px 0px', threshold: 0 }
      );

      const footerObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            isFooterInViewport = entry.isIntersecting;
            updateStickyState();
          });
        },
        { rootMargin: '0px 0px 0px 0px', threshold: 0 }
      );

      productFormObserver.observe(productForm);
      footerObserver.observe(footerSection);

      productStickyClose.addEventListener('click', (e) => {
        e.preventDefault();
        productFormObserver.disconnect();
        footerObserver.disconnect();
        productSticky.remove();
      });
    }
  });

  // Product Zoom Popup
  (function () {
    const modal = document.getElementById('product-zoom-modal');
    if (!modal) return;

    const zoomImage = modal.querySelector('[data-zoom-image]');
    const zoomContainer = modal.querySelector('[data-zoom-container]');
    const closeEls = modal.querySelectorAll('[data-zoom-close]');
    const prevBtn = modal.querySelector('[data-zoom-prev]');
    const nextBtn = modal.querySelector('[data-zoom-next]');
    const counter = modal.querySelector('[data-zoom-counter]');
    const thumbsContainer = modal.querySelector('[data-zoom-thumbs]');
    const panel = modal.querySelector('[data-zoom-panel]');

    const imageSlides = [...document.querySelectorAll('.product-images__slide')]
      .filter((slide) => slide.querySelector('.product-images__image img'));

    if (!imageSlides.length) return;

    const hasMultiple = imageSlides.length > 1;
    let currentIndex = 0;
    let lastTrigger = null;

    const getImageSrc = (slideEl) => {
      const img = slideEl.querySelector('.product-images__image img');
      // Prefer the largest srcset entry, fall back to src
      if (img.srcset) {
        const parts = img.srcset.split(',').map((s) => s.trim().split(' '));
        const largest = parts.sort((a, b) => parseInt(b[1], 10) - parseInt(a[1], 10))[0];
        if (largest) return largest[0];
      }
      return img.src;
    };

    const isZoomed = () => zoomContainer.classList.contains('is-zoomed');

    const setZoom = (zoomed) => {
      zoomContainer.classList.toggle('is-zoomed', zoomed);
      if (!zoomed) zoomImage.style.transformOrigin = 'center center';
    };

    // Point the zoom at the cursor/finger position on the (unscaled) image
    const updateOrigin = (clientX, clientY) => {
      const rect = zoomContainer.getBoundingClientRect();
      const w = zoomImage.offsetWidth;
      const h = zoomImage.offsetHeight;
      if (!w || !h) return;
      const left = rect.left + (rect.width - w) / 2;
      const top = rect.top + (rect.height - h) / 2;
      const x = Math.min(Math.max(((clientX - left) / w) * 100, 0), 100);
      const y = Math.min(Math.max(((clientY - top) / h) * 100, 0), 100);
      zoomImage.style.transformOrigin = x + '% ' + y + '%';
    };

    // Build thumbnail strip
    const thumbButtons = imageSlides.map((slide, i) => {
      const sourceImg = slide.querySelector('.product-images__image img');
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product-zoom__thumb';
      btn.setAttribute('aria-label', 'View image ' + (i + 1));
      const img = document.createElement('img');
      img.src = sourceImg.currentSrc || sourceImg.src;
      img.alt = '';
      btn.appendChild(img);
      btn.addEventListener('click', () => loadSlide(i));
      thumbsContainer.appendChild(btn);
      return btn;
    });

    if (!hasMultiple) {
      thumbsContainer.hidden = true;
      counter.hidden = true;
      panel.classList.add('is-single');
    }

    const loadSlide = (index) => {
      if (index < 0 || index >= imageSlides.length) return;
      currentIndex = index;
      const slide = imageSlides[index];

      setZoom(false);
      zoomImage.src = getImageSrc(slide);
      zoomImage.alt = slide.querySelector('img')?.alt || '';

      prevBtn.style.display = !hasMultiple || index === 0 ? 'none' : '';
      nextBtn.style.display = !hasMultiple || index === imageSlides.length - 1 ? 'none' : '';
      counter.textContent = index + 1 + ' / ' + imageSlides.length;

      thumbButtons.forEach((btn, i) => btn.classList.toggle('is-active', i === index));
      const activeThumb = thumbButtons[index];
      if (activeThumb) {
        // Works for the vertical strip (desktop) and horizontal strip (mobile)
        thumbsContainer.scrollTo({
          left: activeThumb.offsetLeft - (thumbsContainer.clientWidth - activeThumb.offsetWidth) / 2,
          top: activeThumb.offsetTop - (thumbsContainer.clientHeight - activeThumb.offsetHeight) / 2,
          behavior: 'smooth',
        });
      }
    };

    const openModal = (index, trigger) => {
      lastTrigger = trigger || null;
      document.body.appendChild(modal); // escape stacking context
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      loadSlide(index);
      modal.querySelector('.product-zoom__close')?.focus();
    };

    const closeModal = () => {
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      setZoom(false);
      lastTrigger?.focus();
    };

    // Clicking anywhere on a product image opens the zoom popup
    document.querySelectorAll('.product-images__slide .product-images__image').forEach((imageEl) => {
      const slide = imageEl.closest('.product-images__slide');
      const index = parseInt(slide.dataset.index, 10);
      const slideIndex = imageSlides.findIndex((s) => parseInt(s.dataset.index, 10) === index);
      const open = () => openModal(slideIndex >= 0 ? slideIndex : 0, imageEl);

      // Keyboard users can tab to the image and press Enter/Space
      imageEl.setAttribute('role', 'button');
      imageEl.setAttribute('tabindex', '0');
      imageEl.setAttribute('aria-label', 'Zoom image');

      imageEl.addEventListener('click', open);
      imageEl.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          open();
        }
      });
    });

    closeEls.forEach((el) => el.addEventListener('click', closeModal));
    prevBtn?.addEventListener('click', () => loadSlide(currentIndex - 1));
    nextBtn?.addEventListener('click', () => loadSlide(currentIndex + 1));

    // Click image to zoom into that point / click again to zoom out
    zoomImage.addEventListener('click', (e) => {
      const zooming = !isZoomed();
      if (zooming) updateOrigin(e.clientX, e.clientY);
      setZoom(zooming);
    });

    // Pan while zoomed (mouse)
    modal.addEventListener('mousemove', (e) => {
      if (isZoomed()) updateOrigin(e.clientX, e.clientY);
    });

    // Touch: pan while zoomed, swipe to change image when not zoomed
    let touchStartX = 0;
    let touchStartY = 0;
    let touchOnThumbs = false;

    modal.addEventListener('touchstart', (e) => {
      const t = e.changedTouches[0];
      touchStartX = t.clientX;
      touchStartY = t.clientY;
      touchOnThumbs = !!e.target.closest('[data-zoom-thumbs]');
    }, { passive: true });

    modal.addEventListener('touchmove', (e) => {
      if (!isZoomed()) return;
      const t = e.changedTouches[0];
      updateOrigin(t.clientX, t.clientY);
    }, { passive: true });

    modal.addEventListener('touchend', (e) => {
      if (isZoomed() || touchOnThumbs || !hasMultiple) return;
      const t = e.changedTouches[0];
      const dx = t.clientX - touchStartX;
      const dy = t.clientY - touchStartY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
        loadSlide(currentIndex + (dx < 0 ? 1 : -1));
      }
    });

    // Keyboard
    modal.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowLeft') loadSlide(currentIndex - 1);
      if (e.key === 'ArrowRight') loadSlide(currentIndex + 1);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promobar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', async () => {
    const { Swiper } = await import('@theme/swiper');

    const sections = document.querySelectorAll('[data-promobar]');

    sections.forEach((section) => {
      const carousel = section.querySelector('[data-carousel]');
      const autoplayEnabled = section.dataset.autoplayEnabled === 'true';
      const autoplayDelay = parseInt(section.dataset.autoplayDelay) || 4000;
      const speed = parseInt(section.dataset.speed) || 400;

      const slides = carousel.querySelectorAll('.swiper-slide');
      if (slides.length <= 1) return;

      const swiper = new Swiper(carousel, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: false,
        effect: 'slide',
        speed,
        grabCursor: false,
      });

      if (autoplayEnabled) {
        setInterval(() => swiper.slideNext(), autoplayDelay);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-drawer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const closeButtons = document.querySelectorAll(
      '[data-search-drawer-close]'
    );

    closeButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.remove('is-search-drawer-open');
        document.body.removeAttribute('data-lock-scroll');
      });
    });

    let searchInput = null;
    const drawer = document.querySelector('.search-drawer');

    const focusSearchInput = () => {
      searchInput ??= document.querySelector('.search-drawer__input .aa-Input');
      searchInput?.focus();
    };

    const drawerObserver = new MutationObserver(() => {
      if (!document.body.classList.contains('is-search-drawer-open')) return;

      if (!drawer) {
        focusSearchInput();
        return;
      }

      drawer.addEventListener('transitionend', focusSearchInput, { once: true });
    });

    drawerObserver.observe(document.body, { attributeFilter: ['class'] });
  });

  // Theme editor: open the drawer while this section is selected so the default content can be previewed
  const isSearchDrawerSection = (event) =>
    event.target instanceof Element && event.target.querySelector('[data-search-drawer]');

  document.addEventListener('shopify:section:select', (event) => {
    if (!isSearchDrawerSection(event)) return;
    document.body.classList.add('is-search-drawer-open');
  });

  document.addEventListener('shopify:section:deselect', (event) => {
    if (!isSearchDrawerSection(event)) return;
    document.body.classList.remove('is-search-drawer-open');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suggested-links"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', async () => {
    const { Swiper } = await import('@theme/swiper');

    const sections = document.querySelectorAll('[data-suggested-links]');

    sections.forEach((section) => {
      const carousel = section.querySelector('[data-carousel]');

      const slides = carousel.querySelectorAll('.swiper-slide');
      if (slides.length <= 1) return;

      const swiperConfig = {
        slidesPerView: 'auto',
        spaceBetween: 16,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
        allowTouchMove: true,
        effect: 'slide',
        speed: 400,
        freeMode: true,
        grabCursor: true,
        breakpoints: {
          990: {
            slidesOffsetBefore: 64,
            slidesOffsetAfter: 64,
          },
        },
      };

      const swiper = new Swiper(carousel, swiperConfig);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
